// extracted by mini-css-extract-plugin
module.exports = {"title":"course-card-title_title__tvSBS","course-title":"course-card-title_course-title___sH9w"};